module.exports = __webpack_public_path__ + "static/media/miki.392c903d.jpg";